import { MenuItem, Text } from '@chakra-ui/react';
import { Icon, IconKey } from '@jurnee/common/src/components/Icon';

interface Props {
  icon?: IconKey;
  label: string;
  isDisabled?: boolean;
  onClick?: React.MouseEventHandler;
}

export function MenuItemWrapper(props: Props) {
  return (
    <MenuItem onClick={props.onClick} isDisabled={props.isDisabled}>
      {props.icon ? <Icon size={5} icon={props.icon} /> : null}
      <Text ml={props.icon ? 3 : 0} fontSize={14} textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
        {props.label}
      </Text>
    </MenuItem>
  );
};